import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getContentHealth } from '../services/content-runs.service';
import type { ContentDependencyStatus } from '../types/content.types';

/** How often readiness is re-checked while a Content page is open. */
const HEALTH_POLL_MS = 60_000;

/**
 * Content-service readiness (ClickHouse, Temporal), polled every minute.
 * The endpoint answers 503 when degraded; the service reads that body instead of
 * throwing (`throwHttpErrors: false`), so `checks` is available either way.
 */
export function useContentHealth() {
  return useQuery({
    queryKey: queryKeys.content.health(),
    queryFn: getContentHealth,
    refetchInterval: HEALTH_POLL_MS,
    staleTime: HEALTH_POLL_MS / 2,
    // A probe that fails outright is retried by the next poll, not hammered now.
    retry: false,
  });
}

/** Dependencies that are actually DOWN. `disabled` is a deliberate operator choice, not a failure. */
export function downDependencies(checks: readonly ContentDependencyStatus[] | undefined) {
  return (checks ?? []).filter((check) => check.status.toLowerCase() === 'down');
}
